import { render, staticRenderFns } from "./AddrSelect.vue?vue&type=template&id=77bd1ddb&scoped=true&"
import script from "./AddrSelect.vue?vue&type=script&lang=js&"
export * from "./AddrSelect.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77bd1ddb",
  null
  
)

export default component.exports